import { render } from "./FAQAccordion.vue?vue&type=template&id=0451cd6c"
import script from "./FAQAccordion.vue?vue&type=script&lang=js"
export * from "./FAQAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__